import React, { useEffect } from "react";
import { Button, Spinner } from "reactstrap";
import { useForm, FieldErrors } from "react-hook-form";
import CommonForm from "../../../../Components/Common/CommonForm";
import { StudyRoleFormValues } from "../helper/role.types";
import { roleFormFields } from "../helper/roleconstant";

/* ---------- Types ---------- */

interface AddEditStudyRoleProps {
  existingData?: Partial<StudyRoleFormValues> | null;
  onSave: (data: StudyRoleFormValues) => void | Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

/* ---------- Component ---------- */

const AddEditRole: React.FC<AddEditStudyRoleProps> = ({
  existingData = {},
  onSave,
  onCancel,
  loading = false,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<StudyRoleFormValues>({
    defaultValues: existingData || {},
    mode: "onChange",
  });

  useEffect(() => {
    if (existingData) reset(existingData);
  }, [existingData, reset]);

  /* -----------------------------------------
   * Submit Handler
   * ----------------------------------------- */

  const onSubmit = async (values: StudyRoleFormValues) => {
    await onSave({ ...existingData, ...values });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CommonForm
        fields={roleFormFields}
        control={control}
        errors={errors as FieldErrors}
        columns={1}
      />
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button type="button" color="dark" outline onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="submit"
          color="primary"
          outline
          disabled={loading || isSubmitting}
        >
          {(loading || isSubmitting) && <Spinner size="sm" className="me-2" />}
          Save
        </Button>
      </div>
    </form>
  );
};

export default AddEditRole;
